export const logConstants = {
  LOG_LIST_REQUEST: 'LOG_LIST_REQUEST',
  LOG_LIST_SUCCESS: 'LOG_LIST_SUCCESS',
  LOG_LIST_FAILURE: 'LOG_LIST_FAILURE',
  LOG_LIST_CHANGED: 'LOG_LIST_CHANGED',
  LOG_LIST_PAGINATION: 'LOG_LIST_PAGINATION',

};
